module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headeracknow01",
      "epub:type": "acknowledgments",
      "id": "acknow",
      "role": "doc-acknowledgments"
    }
  }, [_c('header', {
    attrs: {
      "id": "headeracknow01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "viii",
      "epub:type": "pagebreak",
      "id": "pviii",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ix",
      "epub:type": "pagebreak",
      "id": "pix",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsutvmparksandrec0007#racknow"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("riting this book was like getting the opportunity to write a long love letter to a show that carried me through the latter half of my twenties. Visiting Pawnee on Thursday nights was a respite from everyday life during a period when I very much needed it, and I feel profoundly lucky that my research allows me to investigate and pay tribute to this special show.")]), _vm._v(" "), _c('p', [_vm._v("This project would not have been possible without the support I received along the way. Thank you to my editors at Wayne State University Press, Marie Sweetman and series editor Barry Grant, for believing that my work would make a valuable contribution to the TV Milestones series. I am greatly appreciative of the anonymous peer reviewers and WSUP editorial board members who provided the instrumental feedback necessary to make this book both engaging and analytically sound.")]), _vm._v(" "), _c('p', [_vm._v("Thank you to my parents, who binge-watched "), _c('i', [_vm._v("Parks")]), _vm._v(" in preparation to read my book. You have always believed in my ability to rise to life’s challenges and succeed.")]), _vm._v(" "), _c('p', [_vm._v("Chan and Jeremy, truly two of the best guys I know, thank you for reading and offering feedback on a draft of this book. I am immeasurably grateful for both of you.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "x",
      "epub:type": "pagebreak",
      "id": "px",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Female friendship is central to "), _c('i', [_vm._v("Parks")]), _vm._v(", and my life would be far less rich without my network of girlfriends—Jenny, Cass, Danee, Rachel, Amanda, Sara, Melissa, Kristi, Angela, Marlo, Cristina, Deb—some of whom have watched episodes of "), _c('i', [_vm._v("Parks")]), _vm._v(" with me and all of whom have shown me the immense power and necessity of female friendship. Special thanks to my person, Elizabeth, who has supported me and gassed me up endlessly. You are a beautiful, talented, brilliant, powerful musk ox who will forever be the Ann to my Leslie.")]), _vm._v(" "), _c('p', [_vm._v("And to Nicholas. I have the words to thank all the others, but words will never be enough to thank you.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47bfc3f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-tvmparksandrec-0008.vue
// module id = 75
// module chunks = 0